import React from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import {Badge} from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';
import Image from "@material-tailwind/react/Image";
import styled from 'styled-components';

import UiTM_icon from '../assets/images/contents/UiTM_Logo.svg';

const Styles = styled.div`  
.nav-link {
    color: green;
}

.button:active {
    background-color: gray;
}

.button:focus {
    outline-color: transparent;
    outline-style:solid;
    box-shadow: 0 0 0 4px #5a01a7;
    transition: 0.7s;
}

.nav-item>a:hover {
    color: green;
}

/*code to change background color*/
.navbar-nav>.active>a {
    background-color: #C0C0C0;
    color: green;
}`
      
export var Navigation = function(props){
    return(
        <Styles>
        <div className="navigation">
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark" 
                style={{"box-shadow": "10px 10px 5px grey", "margin-top": "10px", padding: ".5rem, 12rem"}}>
                <div class="container">
                 
                    <Image
                        position="left"
                        src={UiTM_icon}
                        rounded={false}
                        raised={false}
                        width= '200rem'
                        alt="Logo scds2023"
                    />
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" 
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto">
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2023/home">Home
                                    <span class="sr-only">(current)</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2023/callPapers">Call for Papers</Link>
                            </li>
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2023/dates">Important Dates</Link>
                            </li>
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2023/proceeding">Proceeding <Badge pill variant="danger"></Badge>{" "}</Link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Information
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/programBook" style={{color: 'black'}}>Program Book </Link>
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/submissionGuideline" style={{color: 'black'}}>Submission Guideline </Link>
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/feePayment" style={{color: 'black'}}>Fee and Payment</Link>
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/registration" style={{color: 'black'}}>Registration</Link>
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/publication" style={{color: 'black'}}>Publication</Link>
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/venue" style={{color: 'black'}}>Venue</Link>
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/copyright" style={{color: 'black'}}>Copyright</Link>
                                    </li>
                                    {/* <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2023/visa" style={{color: 'black'}}>Visas & Letter of Invitation</Link>
                                    </li> */}
                                    {/* <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2023/bestPaper" style={{color: 'black'}}>Best Paper Award <Badge pill variant="danger">New</Badge>{" "}</Link>
                                    </li> */}
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Committee
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/committee" style={{color: 'black'}}>Technical Committee</Link>                           
                                    </li>
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/organizer" style={{color: 'black'}}>International Scientific Committee</Link>                              
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    About
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    {/* <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2023/previousscds" style={{color: 'black'}}>Previous SCDS</Link>                                 
                                    </li> */}
                                    <li class="dropdown-item button">
                                        <Link class="nav-link" to="/scds2023/contact" style={{color: 'black'}}>Contact Us</Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        
                    </div>
                </div>
            </nav>
        </div>
        </Styles>
    );
}

export default Navigation;